import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d20a9c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "public-badges-page"
}
const _hoisted_2 = { class: "card breadcrumb-card mb-5 mt-5" }
const _hoisted_3 = { class: "breadcrumb-inner" }
const _hoisted_4 = { class: "symbol symbol-45px symbol-circle" }
const _hoisted_5 = { class: "symbol-label" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "breadcrumb-sep" }, "»", -1))
const _hoisted_8 = { class: "breadcrumb-current" }
const _hoisted_9 = { class: "badges-page-title" }
const _hoisted_10 = { class: "badges-page-count" }
const _hoisted_11 = { class: "card badges-full-card" }
const _hoisted_12 = {
  key: 0,
  class: "badges-full-grid"
}
const _hoisted_13 = { class: "badge-square-icon" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "badge-square-date"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-check" }, null, -1))
const _hoisted_17 = { class: "badge-square-name" }
const _hoisted_18 = {
  key: 2,
  class: "badge-square-ownership"
}
const _hoisted_19 = {
  key: 3,
  class: "badge-square-desc"
}
const _hoisted_20 = {
  key: 1,
  class: "badges-full-empty"
}
const _hoisted_21 = { class: "fw-bold fs-5 text-center px-6" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  class: "d-flex justify-content-center",
  style: {"height":"1024px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary spinner-lg mr-15" }, null, -1))
const _hoisted_25 = { class: "fs-4 text-gray-700 mt-10" }

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import moment from "moment";
import { Actions } from "@/store/enums/StoreEnums";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const $route = useRoute();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const userPublic = computed(() => store.getters.publicUser || {});
const loading = ref(false);

const slugify = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const badgeImage = (badge: any) => {
  const normalize = (value?: string | null) => {
    if (!value) return null;
    if (value.startsWith("/media/badges/")) return value.replace("/media/badges/", "/media/logos/badges/");
    return value;
  };
  return (
    normalize(badge?.photo_path) ||
    normalize(badge?.photoUrl) ||
    normalize(badge?.image) ||
    (badge?.slug ? `/media/logos/badges/${badge.slug}.png` : null) ||
    (badge?.name ? `/media/logos/badges/${slugify(badge.name)}.png` : null)
  );
};

// Backend field names for acquisition date / ownership percentage aren't
// finalized yet — accept a few likely shapes so the UI lights up as soon as
// any of them is returned.
const acquiredAt = (badge: any) => badge?.acquired_at ?? badge?.pivot?.created_at ?? badge?.created_at ?? null;

const formatDate = (date: string) => moment(date).format("D [de] MMM. YYYY");

const ownershipPercentage = (badge: any): number | null => {
  const value = badge?.owners_percentage ?? badge?.rarity_percentage ?? badge?.percentage ?? null;
  return value === null || value === undefined ? null : Number(Number(value).toFixed(1));
};

const ownedBadges = computed(() => {
  const allBadges = userPublic.value?.badges || [];
  const userId = userPublic.value?.id;

  const hasOwnershipMarkers = allBadges.some(
    (b: any) => "user_id" in b || "badge_id" in b || "owned" in b || "has_badge" in b
  );

  if (!hasOwnershipMarkers) return allBadges;

  return allBadges.filter((b: any) => {
    if (userId && b?.user_id) return b.user_id === userId;
    return Boolean(b?.badge_id ?? b?.owned ?? b?.has_badge);
  });
});

const loadPublicUser = async (id: string | string[] | undefined) => {
  const routeId = Array.isArray(id) ? id[0] : id;
  try {
    loading.value = true;
    await store.dispatch(Actions.GET_PUBLIC_USER, { id: routeId });
  } catch (e) {
    console.log(e);
  } finally {
    loading.value = false;
  }
};

onBeforeMount(async () => {
  await loadPublicUser($route.params.id);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("img", {
                  src: _unref(userPublic).avatar,
                  class: "h-75 align-self-center",
                  alt: ""
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createVNode(_component_router_link, {
              to: { name: 'profile-user', params: { id: _unref($route).params.id } },
              class: "breadcrumb-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(userPublic).nick || _unref(userPublic).name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.badges`)), 1)
          ])
        ]),
        _createElementVNode("h2", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.all_badges_of`)) + " ", 1),
          _createElementVNode("strong", null, _toDisplayString(_unref(userPublic).nick || _unref(userPublic).name), 1),
          _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(String(_unref(ownedBadges).length).padStart(2, '0')) + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_unref(ownedBadges).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ownedBadges), (badge, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: badge?.id ?? idx,
                    class: "badge-square-card"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      (badgeImage(badge))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: badgeImage(badge),
                            alt: badge?.name
                          }, null, 8, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    (acquiredAt(badge))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(formatDate(acquiredAt(badge))), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(badge?.name), 1),
                    (badge?.rarity_label)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["badge-rarity-chip", `rarity-${badge?.rarity_tier}`])
                        }, _toDisplayString(badge.rarity_label), 3))
                      : _createCommentVNode("", true),
                    (ownershipPercentage(badge) !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(ownershipPercentage(badge)) + "% " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.of_students`)), 1))
                      : _createCommentVNode("", true),
                    (badge?.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(badge.description), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.no_badges_yet`)), 1)
              ]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
        ])
      ]))
}
}

})